import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_AUDIO_TRANSLATION, CLEAR_RECEIVING_TRANSLATED_SOURCES, SET_AUDIO_TRANSLATION_LANGUAGE, SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE, SET_TRANSLATION_LISTENERS, UPDATE_TRANSLATED_SOURCE_SENDING } from './actionTypes';
const DEFAULT_STATE = {
    language: null,
    participantLanguages: {},
    receivingSources: [],
    translationListeners: []
};
ReducerRegistry.register('features/audio-translation', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CLEAR_AUDIO_TRANSLATION:
            return DEFAULT_STATE;
        case CLEAR_RECEIVING_TRANSLATED_SOURCES:
            return {
                ...state,
                receivingSources: []
            };
        case SET_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                language: action.language
            };
        case SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                participantLanguages: {
                    ...state.participantLanguages,
                    [action.participantId]: action.language
                }
            };
        case SET_TRANSLATION_LISTENERS:
            return {
                ...state,
                translationListeners: action.ids
            };
        case UPDATE_TRANSLATED_SOURCE_SENDING: {
            const has = state.receivingSources.includes(action.sourceName);
            if (action.sending === has) {
                return state;
            }
            return {
                ...state,
                receivingSources: action.sending
                    ? [...state.receivingSources, action.sourceName]
                    : state.receivingSources.filter((source) => source !== action.sourceName)
            };
        }
        default:
            return state;
    }
});
